import React from "react";
import construction from "../../assets/images/site-underwork.png";
import { Link } from "react-router-dom";

const UnderConstruction = () => {
  return (
    <div className="flex justify-center items-center p-10 flex-col">
      <img src={construction} alt="Page is under construction." />
      <p className="text-sm pt-4">
        This is page is under construction.{" "}
        <Link
          to="/"
          className="bgRed text-white px-4 py-2 ml-4 rounded-md underline"
        >
          Go to Homepage
        </Link>
      </p>
    </div>
  );
};

export default UnderConstruction;
